import common from '../common'
import { FORMATS } from '@/global/services/date'
import { api } from '@/global/services/api'

const TAB_KEY = 'basic-info'
export default {
  name: 'basicInfoConfig',

  mixins: [
    common
  ],

  data () {
    return {
      basicInfoPermissions: {},
      dynamicFieldTemplateItems: {},
      foreignIdAutocompleteItems: []
    }
  },

  computed: {
    basicInfo () {
      return {
        title: this.$t('fleet/vehicle.basic_info'),
        key: TAB_KEY,
        apiConfig: {
          post: {
            module: 'fleet',
            route: `travel-documents/prl-cargo/basic-info/${this.$route.params.id}`,
            method: 'post'
          },
          get: {
            module: 'fleet',
            route: `travel-documents/prl-cargo/basic-info/${this.$route.params.id}`,
            method: 'get'
          }
        },
        hiddenFormKeys: [
          'vehicle_id',
          'trailer_id',
          'crew_members'
        ],
        permissions: this.basicInfoPermissions,
        onDataReceived: (data) => {
          const { meta } = data || {}
          const { permissions } = meta || {}
          this.$set(this.basicInfoPermissions, 'canEdit', permissions?.canEdit !== undefined ? permissions.canEdit : false)
          this.$set(this.basicInfoPermissions, 'canImportCrew', permissions?.canImportCrew !== undefined ? permissions.canImportCrew : false)
          this.$set(this.basicInfoPermissions, 'canChangeStatus', permissions?.canChangeStatus !== undefined ? permissions.canChangeStatus : false)
        },
        additionalSetup: async (event) => await this.callBasicInfoAdditionalSetup(event),
        tabContent: [
          // PRL data card
          {
            title: this.$t('fleet/vehicle.basic_info'),
            subTitle: this.$t('fleet/documents/prl_cargo.data_of_prl'),
            component: this.columnsContentComponent,
            showButtons: true,
            showBackButton: {
              uiViewName: 'PrlCargo'
            },
            additional_buttons: [
              {
                type: 'base',
                label: this.$t('fleet/documents/prl_cargo.load_crew'),
                prependIcon: 'mdi-download',
                visible: (event) => {
                  const { permissions } = event || {}

                  return permissions && permissions.canImportCrew
                },
                click: (event) => this.getCrewMembers(event)
              },
              {
                type: 'base',
                label: this.$t('fleet/documents/prl_cargo.view_pdf'),
                prependIcon: 'mdi-file-pdf-box',
                click: () => this.onBasicInfoViewPdf()
              },
              {
                type: 'base',
                label: this.$t('fleet/documents/prl_cargo.change_status'),
                prependIcon: 'mdi-swap-horizontal',
                visible: (event) => {
                  const { permissions } = event || {}

                  return permissions && permissions.canChangeStatus
                },
                click: (event) => this.onChangeStatus(event, 'basic-info')
              }
            ],
            rows: [
              {
                type: 'fields',
                columnsCount: 4,
                fields: [
                  {
                    key: 'foreign_code',
                    label: this.$t('fleet/documents/prl_cargo.prl_no'),
                    row: 1,
                    column: 1,
                    creatable: true,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'date_time',
                    label: this.$t('fleet/documents/prl_cargo.creation_date'),
                    type: 'datetime-picker',
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.datetimeShort,
                    placeholder: FORMATS.datetimeShort,
                    row: 1,
                    column: 2,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'status_name',
                    label: this.$t('fleet/vehicle.status'),
                    options: {
                      custom_display_value: (value) => {
                        return value ? this.$t(value) : ''
                      }
                    },
                    row: 1,
                    column: 3,
                    creatable: true,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'transport_type',
                    label: this.$t('fleet/documents/prl_cargo.transport_type'),
                    options: {
                      custom_display_value: (value) => {
                        return value ? this.$t(value) : ''
                      }
                    },
                    creatable: true,
                    row: 1,
                    column: 4,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'company_name',
                    label: this.$t('fleet/documents/prl_cargo.company_name_and_address'),
                    creatable: true,
                    row: 2,
                    column: 1,
                    colSpan: 2,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'organizational_unit',
                    label: this.$t('fleet.organizational_unit'),
                    creatable: true,
                    row: 2,
                    column: 3,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'department',
                    label: this.$t('fleet.department'),
                    creatable: true,
                    row: 2,
                    column: 4,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'relation',
                    label: this.$t('fleet/documents/prl_cargo.relation_or_direction'),
                    placeholder: this.$t('fleet/documents/prl_cargo.relation_or_direction_placeholder'),
                    creatable: true,
                    row: 3,
                    column: 1,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'foreign_id',
                    label: this.$t('fleet/documents/prl_cargo.foreign_id'),
                    row: 3,
                    column: 2,
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'codebook/autocomplete',
                      queryParams: {
                        type: 'TRAVEL_DOCUMENT_FOREIGN_ID'
                      },
                      fetchInitial: false,
                      custom_display_value: (item) => {
                        return item && item.description ? item.description : null
                      },
                      form_value: 'name'
                    },
                    items: this.foreignIdAutocompleteItems,
                    creatable: true,
                    editable: true,
                    visible: !!this.foreignIdAutocompleteItems?.length
                  },
                  {
                    key: 'foreign_id',
                    label: this.$t('fleet/documents/prl_cargo.foreign_id'),
                    row: 3,
                    column: 2,
                    creatable: true,
                    editable: true,
                    visible: !this.foreignIdAutocompleteItems?.length
                  }
                ]
              }
            ]
          },
          // Crew members card
          {
            subTitle: this.$t('fleet/documents/prl_cargo.crew_members'),
            component: this.dynamicCreatedFieldsComponent,
            dataKey: 'crew_members',
            columnsCount: 3,
            fields: [
              {
                key: 'driver_name',
                label: this.$t('fleet/vehicle.driver'),
                creatable: true,
                editable: false,
                visible: true
              }
            ],
            dynamicFieldTemplate: {
              key: 'id',
              label: this.$t('fleet/documents/prl_cargo.other_crew_members').replace(':number', ''),
              type: 'autocomplete',
              autocomplete_options: {
                module: 'people',
                route: 'people/autocomplete',
                fetchInitial: false,
                returnValue: 'object'
              },
              items: this.dynamicFieldTemplateItems,
              creatable: true,
              editable: true,
              visible: true
            }
          },
          // Vehicle and trailer data card
          {
            subTitle: this.$t('fleet/documents/prl_cargo.vehicle_and_trailer_data'),
            component: this.columnsContentComponent,
            fullWidth: true,
            rows: [
              {
                type: 'fields',
                columnsCount: 3,
                fields: [
                  {
                    key: 'vehicle_brand',
                    label: this.$t('fleet/documents/prl_cargo.vehicle_brand'),
                    creatable: true,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'vehicle_registration',
                    label: this.$t('fleet/vehicle.registration'),
                    placeholder: this.$t('fleet/documents/prl_cargo.registration_number_placeholder'),
                    type: 'autocomplete',
                    onSelect: (event) => this.onVehicleRegistrationSelect(event),
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'travel-documents/get-vehicle',
                      custom_display_value: (item) => {
                        if (item && item.vehicle_registration) {
                          return item.vehicle_registration
                        }
                      },
                      additionalQueryParams: (event) => {
                        this.vehicleRegistrationAutocompleteField = event
                        return {
                          by: 'registration',
                          vehicle_type: 'vehicle',
                          document_type: 'PRL_CARGO'
                        }
                      },
                      returnValue: 'object',
                      form_value: 'vehicle_registration'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'vehicle_garage_number',
                    label: this.$t('fleet/vehicle_attribute.garage_number'),
                    placeholder: this.$t('fleet/documents/prl_cargo.garage_number_placeholder'),
                    type: 'autocomplete',
                    onSelect: (event) => this.onVehicleGarageNumberSelect(event),
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'travel-documents/get-vehicle',
                      custom_display_value: (item) => {
                        if (item && item.vehicle_garage_number) {
                          return item.vehicle_garage_number
                        }
                      },
                      additionalQueryParams: (event) => {
                        this.vehicleGarageNumberAutocompleteField = event
                        return {
                          by: 'garage_number',
                          vehicle_type: 'vehicle',
                          document_type: 'PRL_CARGO'
                        }
                      },
                      returnValue: 'object',
                      form_value: 'vehicle_garage_number'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'trailer_brand',
                    label: this.$t('fleet/documents/prl_cargo.trailer_brand'),
                    creatable: true,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'trailer_registration',
                    label: this.$t('fleet/vehicle.registration'),
                    placeholder: this.$t('fleet/documents/prl_cargo.registration_number_placeholder'),
                    type: 'autocomplete',
                    onSelect: (event) => this.onTrailerRegistrationSelect(event),
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'travel-documents/get-vehicle',
                      custom_display_value: (item) => {
                        if (item && item.trailer_registration) {
                          return item.trailer_registration
                        }
                      },
                      additionalQueryParams: {
                        by: 'registration',
                        vehicle_type: 'trailer',
                        document_type: 'PRL_CARGO'
                      },
                      returnValue: 'object',
                      form_value: 'trailer_registration'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'trailer_garage_number',
                    label: this.$t('fleet/vehicle_attribute.garage_number'),
                    placeholder: this.$t('fleet/documents/prl_cargo.garage_number_placeholder'),
                    type: 'autocomplete',
                    onSelect: (event) => this.onTrailerGarageNumberSelect(event),
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'travel-documents/get-vehicle',
                      custom_display_value: (item) => {
                        if (item && item.trailer_garage_number) {
                          return item.trailer_garage_number
                        }
                      },
                      additionalQueryParams: {
                        by: 'garage_number',
                        vehicle_type: 'trailer',
                        document_type: 'PRL_CARGO'
                      },
                      returnValue: 'object',
                      form_value: 'trailer_garage_number'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          // Signature card
          {
            component: this.columnsContentComponent,
            fullWidth: true,
            subTitle: this.$t('fleet/documents/prl_cargo.signature_title'),
            rows: [
              {
                type: 'fields',
                fields: [
                  {
                    type: 'content-with-buttons',
                    label: this.$t('fleet/documents/prl_cargo.drivers_signature'),
                    contentStack: 'horizontal',
                    buttonsSide: 'right',
                    buttonsStack: 'vertical',
                    buttons: [
                      {
                        type: 'save',
                        label: (event) => {
                          const { modifiedFormData } = event || {}
                          return modifiedFormData && !!modifiedFormData.inspection_signature_image ? this.$t('fleet/documents/prl_cargo.signed') : this.$t('base.signed_it')
                        },
                        disabled: (event) => {
                          const { modifiedFormData } = event || {}
                          return modifiedFormData && (!!modifiedFormData.inspection_signature_image || !modifiedFormData.inspection_can_sign)
                        },
                        prependIcon: (event) => {
                          const { modifiedFormData } = event || {}
                          return modifiedFormData && !!modifiedFormData.inspection_signature_image ? 'mdi-check' : 'mdi-draw'
                        },
                        style: {
                          width: '96px'
                        },
                        prependIconStyle: {
                          color: '#FFFFFF !important',
                          marginRight: '4px',
                          fontSize: '19px'
                        },
                        click: (event) => this.sign(event, 'PRL_CARGO_INSPECTION', true)
                      }
                    ],
                    contentType: 'image',
                    contentStyle: {
                      height: '88px',
                      minWidth: '256px',
                      maxWidth: '256px',
                      border: '1px solid #E5E7EB',
                      borderRadius: '16px',
                      marginRight: '10px'
                    },
                    key: 'inspection_signature_image',
                    creatable: false,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    async callBasicInfoAdditionalSetup (event) {
      const { formDataForSend } = event || {}

      const { data: peopleData, has_more: hasMore = false } = await api().people.get('people/autocomplete', {})
      if (peopleData && peopleData.length) {
        this.dynamicFieldTemplateItems = {
          data: peopleData,
          hasMore
        }
      }

      if (formDataForSend && formDataForSend.vehicle_id) {
        this.vehicleRegistrationAutocompleteField.pickedId = formDataForSend.vehicle_id
        this.vehicleGarageNumberAutocompleteField.pickedId = formDataForSend.vehicle_id
      }
    },

    async onBasicInfoViewPdf () {
      await this.exportData(this.$route.params.id)
    },

    sign (event, signatureType = '', fetchSignature = false) {
      const config = {
        title: this.$t('fleet/documents/prl_cargo.sign_document'),
        confirmDialogTitle: this.$t('fleet.sign_document'),
        apiConfig: {
          get: {
            module: 'fleet',
            route: 'travel-documents/get-driver-company-from-user',
            method: 'get'
          },
          post: {
            module: 'fleet',
            route: 'travel-documents/signature',
            method: 'post'
          }
        }
      }
      this.$set(this.signatureDialogData, 'config', config)
      this.$set(this.signatureDialogData, 'fetchSignature', fetchSignature)
      this.$set(this.signatureDialogData, 'signatureType', signatureType)
      this.$set(this.signatureDialogData, 'tabKey', TAB_KEY)
      this.$set(this.signatureDialogData, 'instance', event?.indexPage)
      this.$set(this.signatureDialogData, 'show', true)
    },

    async getCrewMembers (event) {
      const response = await api().fleet.post(`travel-documents/prl-cargo/${this.$route.params.id}/add-crew`)
      if (!response?.data?.success) {
        this.$set(this.informationDialogData, 'message', this.$t('fleet/documents/prl_cargo.crew_members_non_existing'))
        this.$set(this.informationDialogData, 'cancelText', this.$t('base.cancel'))
        this.$set(this.informationDialogData, 'confirmText', this.$t('base.ok'))
        this.$set(this.informationDialogData, 'title', this.$t('base.warning'))
        this.$set(this.informationDialogData, 'callback', () => {
          this.$set(this.informationDialogData, 'show', false)
        })
        this.$set(this.informationDialogData, 'show', true)
      }
      else {
        this.tabsForRefresh = ['basic-info']
      }
    }
  },

  async created () {
    try {
      const { data: foreignIdData } = await api('base').get('codebook/autocomplete', {
        type: 'TRAVEL_DOCUMENT_FOREIGN_ID'
      })
      this.foreignIdAutocompleteItems = foreignIdData
    }
    catch (error) {
      console.error(error)
    }
  }
}
